import React, { useCallback } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { DealersListHeaderWrapper, DealersFoundContainer, DealersSelectedContainer, StyledIcon, } from '../styles/LocationFilter.styles';
import { useFilterData } from '../FilterContextHooks';
import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { dynamicStylingHelper } from '../../utils';
import { CMP_COLOR_UI_TAG_SELECTED_TEXT_DEFAULT_DARK } from '@oneaudi/unified-web-alpha-common';
export const DealersListHeader = ({ dealersList, }) => {
    var _a, _b;
    const filterData = useFilterData();
    const noDealersFoundLabel = useI18n({
        id: `nemo.sc.filter.locationfilter.noDealersFound`,
        defaultMessage: 'dealers found',
    });
    const singleDealerFoundLabel = useI18n({
        id: `nemo.sc.filter.locationfilter.singleDealerFound`,
        defaultMessage: 'dealer found',
    });
    const multipleDealersFoundLabel = useI18n({
        id: `nemo.sc.filter.locationfilter.multipleDealersFound`,
        defaultMessage: 'dealers found',
    });
    const selectedDealersLabel = useI18n({
        id: `nemo.sc.filter.locationfilter.selectedDealers`,
        defaultMessage: 'dealers selected',
    });
    const amountOfDealersFound = (dealersList === null || dealersList === void 0 ? void 0 : dealersList.length) === 0
        ? noDealersFoundLabel
        : (dealersList === null || dealersList === void 0 ? void 0 : dealersList.length) === 1
            ? singleDealerFoundLabel
            : multipleDealersFoundLabel;
    const getAmountOfChosenDealers = useCallback((dealerData) => {
        let dealersChosen = 0;
        if (dealerData) {
            dealerData === null || dealerData === void 0 ? void 0 : dealerData.selectedFilter.forEach((item) => {
                if (item.id !== 'geo')
                    dealersChosen++;
            });
        }
        return dealersChosen;
    }, [filterData]);
    return (React.createElement(DealersListHeaderWrapper, null,
        React.createElement(DealersFoundContainer, null,
            React.createElement(StyledText, { tag: "p", variant: {
                    order: '1',
                    style: 'bold',
                    type: 'copy',
                } }, dealersList === null || dealersList === void 0 ? void 0 : dealersList.length),
            React.createElement("span", null, "\u00A0\u00A0"),
            React.createElement(Text, { tag: "p", variant: {
                    order: '1',
                    style: 'normal',
                    type: 'copy',
                } }, amountOfDealersFound)),
        getAmountOfChosenDealers((_a = filterData === null || filterData === void 0 ? void 0 : filterData.filterOptions) === null || _a === void 0 ? void 0 : _a.dealer) > 0 && (React.createElement(DealersSelectedContainer, null,
            React.createElement(StyledIcon, { name: "select", size: "s" }),
            React.createElement(StyledTextChosenDealers, { tag: "span", variant: {
                    order: dynamicStylingHelper('2', '3'),
                    style: 'normal',
                    type: 'copy',
                } },
                getAmountOfChosenDealers((_b = filterData === null || filterData === void 0 ? void 0 : filterData.filterOptions) === null || _b === void 0 ? void 0 : _b.dealer),
                " ",
                selectedDealersLabel)))));
};
export default DealersListHeader;
const StyledText = styled((props) => React.createElement(Text, Object.assign({}, props))) ``;
const StyledTextChosenDealers = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  color: ${dynamicStylingHelper('', CMP_COLOR_UI_TAG_SELECTED_TEXT_DEFAULT_DARK)};
`;
